import React from "react";
import PropTypes from "prop-types";
import ChatFormInput from "../../shared/ChatFormInput/ChatFormInput";
import SendButton from "../../shared/SendButton/SendButton";
import ContainerReponse from "../../Layout/ContainerReponse/ContainerReponse";
//================ STEP 1 ===============

const HandlePostalCode = ({
                              messageValue,
                              addMessage,
                              addBotMessage,
                              inputDisabled,
                              setInputDisable,
                              setUserInfos,
                              loadingBotMessage,
                              responseBotDelay,
                              setStep,
                              handleChange,
                              updateCity,
                              updateZIPCode,
                              updateAdress,
                          }) => {
    const handleCitySubmit = (e) => {
        e.preventDefault();
        if (messageValue === "") {
            e.preventDefault();
        } else {
            loadingBotMessage(true);
            e.preventDefault();
            addMessage(messageValue);
            setUserInfos(messageValue, "cp");
            setInputDisable(true);
            setTimeout(() => {
                loadingBotMessage(false);
                addBotMessage("Merci. Pour terminer, sur quel numéro de téléphone pouvons-nous vous joindre ?", "bot");
                updateCity();
                updateAdress();
                updateZIPCode();
                setInputDisable(false);
                setStep(3);
                document.body.classList.remove("customHeight");
            }, responseBotDelay);
        }
    };
    return (
        <ContainerReponse>
            <ChatFormInput
                onSubmit={handleCitySubmit}
                toggleFocusOn={inputDisabled}
                type="text"
                label="Quel est votre code postal ?"
                value={messageValue}
                onChange={handleChange}
                valueToActive={messageValue}
                disabled={inputDisabled ? "disabled" : ""}
                required={true}
            >
                <SendButton disabled={inputDisabled || !messageValue ? "disabled" : ""}/>
            </ChatFormInput>
        </ContainerReponse>
    );
};

HandlePostalCode.propTypes = {
    responseBotDelay: PropTypes.number,
    setStep: PropTypes.func,
    handleChange: PropTypes.func,
    setMessageValue: PropTypes.func,
    messageValue: PropTypes.string,
    inputDisabled: PropTypes.bool,
    addMessage: PropTypes.func,
    addBotMessage: PropTypes.func,
    setInputDisable: PropTypes.func,
    setUserInfos: PropTypes.func,
    loadingBotMessage: PropTypes.func,
    updateCity: PropTypes.func,
    updateZIPCode: PropTypes.func,
    updateAdress: PropTypes.func,
};

export default HandlePostalCode;
